import { createReducer } from 'store/utils';
import { RootActions } from 'store/types';
import { stateFactories, actionsHandlers } from 'store/entities/utils';
import { EntityType } from 'store/entities/types';
import { EventReminderWithSendAt } from './types';
import * as actions from './actions';

const stateFactory = stateFactories.createInitialEntitiesStateFactory<EntityType<EventReminderWithSendAt>>();
const initialState = stateFactory.getInitialState();

type State = typeof initialState;
type Actions = RootActions<typeof actions>;

const adminEventRemindersReducer = createReducer<State, Actions>(initialState, {
  [actions.getAdminEventReminders.request.type]: actionsHandlers.handleGetManyRequest,
  [actions.getAdminEventReminders.success.type]: actionsHandlers.handleGetManySuccess,
  [actions.getAdminEventReminders.failure.type]: actionsHandlers.handleGetManyFailure,
  [actions.getAdminEventReminders.reset.type]: actionsHandlers.handleGetManyReset,
  [actions.runtimeUpdateAdminEventReminder.request.type]: actionsHandlers.handleUpdateOneRequest,
  [actions.runtimeUpdateAdminEventReminder.success.type]: actionsHandlers.handleUpdateOneSuccess,
  [actions.runtimeUpdateAdminEventReminder.failure.type]: actionsHandlers.handleUpdateOneFailure,
  [actions.runtimeUpdateAdminEventReminder.reset.type]: actionsHandlers.handleUpdateOneReset,
  [actions.createAdminEventReminder.request.type]: actionsHandlers.handleCreateOneRequest,
  [actions.createAdminEventReminder.success.type]: actionsHandlers.handleCreateOneSuccess,
  [actions.createAdminEventReminder.failure.type]: actionsHandlers.handleCreateOneFailure,
  [actions.createAdminEventReminder.reset.type]: actionsHandlers.handleCreateOneReset,
  [actions.deleteAdminEventReminder.request.type]: actionsHandlers.handleDeleteOneRequest,
  [actions.deleteAdminEventReminder.success.type]: actionsHandlers.handleDeleteOneSuccess,
  [actions.deleteAdminEventReminder.failure.type]: actionsHandlers.handleDeleteOneFailure,
});

export default adminEventRemindersReducer;
